class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    window.addEventListener('load', () => {

      this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 500);

      const facetForm = this.querySelector('form');
      facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

      const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
      if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
      // document.querySelector('.mobile-facets__close').addEventListener('click', () => {
      //   setTimeout(() => {
      //     document.documentElement.classList.remove('overflow-hidden')
      //   }, 500);
      // });
    });
  }


  static initLoadMore(loadMore) {
    const loadingOverlaySpinner = document.querySelector('.load-more-container .loading-overlay__spinner');

    const fadeLoadMore = (btn, value) => {
      if (btn) btn.style.opacity = value
    }

    const appendAndrevealProducts = (items, grid, skin) => {
      items.forEach((item, index) => {
        const skinimage = item.querySelector(`.skinPickerImage[data-imageskin="${skin}"]`)
        if (skinimage !== null) {
          skinimage.classList.add('--is-active')
        } else {
          const defaultSkin = item.querySelector('.skinPickerImage')
          if (defaultSkin) defaultSkin.classList.add('--is-active')
        }
        item.style.opacity = 0
        grid.appendChild(item)
        setTimeout(() => {
          item.style.opacity = 1
        }, index * 300)
      })
    }

    if (loadMore === null) return;

    loadMore?.addEventListener('click', e => {
      e.preventDefault()
      const endpoint = loadMore.getAttribute('data-endpoint')
      const collectionName = loadMore.getAttribute('data-collection')
      const searchTerm = loadMore.getAttribute('data-search-term')
      const page = loadMore.getAttribute('data-page')
      const pages = loadMore.getAttribute('data-pages')

      let url;
      if (endpoint === 'collection' || endpoint === 'collections') {
        url = `/collections/${collectionName}?page=${page}&view=loadMore`
      } else if (endpoint === 'search') {
        url = `/search?q=${searchTerm}&page=${page}&view=loadMore`
      }

      fadeLoadMore(loadMore, 0);
      loadingOverlaySpinner.classList.remove('hidden');
      fetch(url)
        .then(response => response.text())
        .then(data => {
          const parser = new DOMParser();
          const html = parser.parseFromString(data, 'text/html');
          const items = html.querySelectorAll('.grid__item:not(.grid__item--perfect-shade)');
          const grid = document.querySelector('#product-grid');
          let skin = document.querySelector('#drawer-perfect-shade .sofsy-perfect-shade-picker__item-active');
          if (skin === null) {
            skin = 'default';
          }
          fadeLoadMore(loadMore, 0);
          setTimeout(() => {
            // appendAndrevealProducts(items, grid, skin);
            fadeLoadMore(loadMore, 1);
            loadingOverlaySpinner.classList.add('hidden');
            loadMore.setAttribute('data-page', Number(page) + 1);
            loadMore.setAttribute('data-sofsy-track-value', Number(page) + 1) // collection.load_more.tap: the page the next tap loads
            if (Number(page) >= Number(pages)) {
              loadMore.remove();
            }
          }, 500);

        });
    });
  };

  static fireCustomEvent() {
    // fire custom event
    const customEvent = new CustomEvent('facetFilters:change', {
    });

    // dispatch the event
    document.dispatchEvent(customEvent);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }


  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    document.body.scrollTop = document.documentElement.scrollTop = 0;

    setTimeout(() => {
      const loadMore = document.querySelector('.loadMore');
      FacetFiltersForm.initLoadMore(loadMore)
    }, 1500)

  }

  // Filter Skin images

  static filterSkinImages() {
    var activeSkin = localStorage.getItem("activeSkin");
    if (activeSkin) {
      var items = document.querySelectorAll('.sofsy-perfect-shade-picker__item[data-skin="' + activeSkin + '"]');
      items.forEach(item => {
        item.classList.add('sofsy-perfect-shade-picker__item-active');
      });
    } else {
      activeSkin = "default"
    };

    var allImages = document.querySelectorAll('.skinPickerImage');

    allImages.forEach(image => {
      var skins = image.getAttribute('data-imageSkin').split('|');
      if (activeSkin == "default") {
        if (image.classList.contains("skinPickerImage_card")) {
          if (image.classList.contains("skinPickerImage_card--default")) image.style.display = 'block';
        } else image.style.display = 'block';
      }
      else if (skins.includes(activeSkin)) image.style.display = 'block';
      // else image.style.display = 'none';
    });
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.filterSkinImages();
        FacetFiltersForm.fireCustomEvent();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.filterSkinImages();
    FacetFiltersForm.fireCustomEvent();
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      let elementAtIndex = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);
      if (!elementAtIndex) return;

      elementAtIndex.innerHTML = element.innerHTML;
      if (element.classList.contains('hidden')) {
        elementAtIndex.classList.add('hidden');
      }
      else {
        elementAtIndex.classList.remove('hidden');
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    window.addEventListener('load', () => {
      this.querySelectorAll('input')
        .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
      this.setMinAndMaxValues();
    });
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    window.addEventListener('load', () => {
      const facetLink = this.querySelector('a');
      facetLink.setAttribute('role', 'button');
      facetLink.addEventListener('click', this.closeFilter.bind(this));
      facetLink.addEventListener('keyup', (event) => {
        event.preventDefault();
        if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
      });
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    // check all inputs on form to see if they are checked  
    const inputs = form.querySelectorAll('input');
    const checkedInputs = Array.from(inputs).filter(input => input.checked);
    // if no inputs are checked, don't reset the form
    if (checkedInputs.length > 0) {
      form.onActiveFilterClick(event);
    }
    document.documentElement.classList.remove('overflow-hidden')
    this.closest('.mobile-facets__wrapper').querySelector('summary').click();
  }
}

customElements.define('facet-remove', FacetRemove);
